import { Outlet, Navigate } from 'react-router-dom';
import accessTokenService from '../../Services/access-token.service';
import { localizedPath } from '../../utils/localized-route';

export const ProtectedRoute = () => {
  const accessToken = accessTokenService.get();

  if (!accessToken) {
    const params = new URLSearchParams({ dest: window.location.href });
    const redirectTo = localizedPath(`/login?${params.toString()}`);
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet />;
};
